import { render, staticRenderFns } from "./CmgRewardQRModal.vue?vue&type=template&id=5740b99f&scoped=true&lang=pug"
import script from "./cmg-reward-q-r-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-q-r-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardQRModal.vue?vue&type=style&index=0&id=5740b99f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740b99f",
  null
  
)

export default component.exports